
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/custom-params-headers.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/custom-params-headers.md?type=demo')
};